import propTypes from 'prop-types'
import Typography from '../../common/Typography/index'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'

const containerStyle = {
  width: '100%',
  height: '200px',
}

const ProximityMap = ({ center, proximity }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // replace with your key
  })

  if (!isLoaded)
    return (
      <div>
        <Typography variant="body" align="center">
          Loading map...
        </Typography>
      </div>
    )

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
      {proximity.map(location => (
        <Marker
          key={location._id}
          label={location.type[0]}
          position={{ lat: location.latitude, lng: location.longitude }}
          title={`${location.name} (${location.type}) - ${location.distance} km`}
        />
      ))}
    </GoogleMap>
  )
}

export default ProximityMap

ProximityMap.propTypes = {
  center: propTypes.object.isRequired,
  proximity: propTypes.arrayOf(
    propTypes.shape({
      latitude: propTypes.number.isRequired,
      longitude: propTypes.number.isRequired,
      name: propTypes.string.isRequired,
      type: propTypes.string.isRequired,
      distance: propTypes.number.isRequired,
      _id: propTypes.string.isRequired,
    })
  ),
}
